import { Grid } from '@mui/material';
import React, { MouseEventHandler } from 'react';
import { AppDivider, Button } from '..';
import './BoxSearch.scss';

interface BoxSearchProps {
  onSearch?: MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
}

const AppBoxSearch: React.FC<BoxSearchProps> = ({ onSearch, children }) => {
  return (
    <div className="BoxSearch">
      <div className="BoxSearch__wrapper">
        <Grid container flex={1} spacing={2}>
          {children}
        </Grid>
        <Button onClick={onSearch} title="common.box_search" />
      </div>
      <AppDivider />
    </div>
  );
};

export default AppBoxSearch;
